import { render, staticRenderFns } from "./If.vue?vue&type=template&id=5ea06096&"
import script from "./If.vue?vue&type=script&lang=js&"
export * from "./If.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports